'use strict';

import {getVueTemplate} from '../../../_imports/utils/utils.common.js';
import BaseVueComponent from "../../../_imports/shared/base-vue-component.vue.common.js";
import SeeMoreContent from "./see-more-content.vue.js";

export default {
    template: getVueTemplate('video-transcript'),
    mixins: [
        BaseVueComponent,
        SeeMoreContent
    ],
    data() {
        return {
            transcriptTag: null
        }
    },
    methods: {
        hasTranscript() {
            return this.transcriptTag?.shadowRoot?.querySelectorAll('[part="paragraph"]:not(:empty)').length > 0;
        },
        // When reopening the video pop up modal, CoveoWebsite.videoApi.onReady is ready before the transcript is loaded and ready
        waitForShadowRoot(timeout = 5000) {
            return new Promise((resolve) => {
                const startTime = Date.now();
                
                const check = () => {
                    const hasContent = this.transcriptTag?.shadowRoot && this.hasTranscript();
                    
                    if (hasContent) {
                        resolve(true);
                    } else if (Date.now() - startTime > timeout) {
                        resolve(false);
                    } else {
                        setTimeout(check, 100);
                    }
                };
                
                check();
            });
        },
        async initTranscriptTag() {
            this.transcriptTag = this.$refs?.transcript?.querySelector('wistia-transcript');
            
            if (this.transcriptTag && this.data?.video?.videoCode) {
                this.transcriptTag.setAttribute('media-id', this.data.video.videoCode);
                
                await this.waitForShadowRoot();
                if (this.hasTranscript()) {
                    this.$refs?.transcript?.classList.add('has-transcript');
                }
            }
        }
    },
    created() {
        if (this.data?.displayTranscript && typeof loadJS !== 'undefined') {
            loadJS('https://fast.wistia.com/assets/external/transcript.js');
        }
    },
    mounted() {
        if (!this.data?.displayTranscript) return;

        CoveoWebsite.videoApi.onReady(this.data?.video?.videoCode, async () => {
            await this.initTranscriptTag();
        });
    },
};